/**
 * Module: ADVANCED-SEARCH
 * Description: TBD
 * Version: 4.0.2022.09191
 */

import { A11yModule } from "@angular/cdk/a11y";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";

import { CommonComponentsModule } from "../../common-components/common-components.module";
import { UmbracoLinkComponent } from "../../common-components/umbraco-link/umbraco-link.component";
import { SharedLibraryModule } from "../../shared-library/shared-library.module";

import { AdvancedSearchComponent } from "./advanced-search.component";
import { ContentCategoryFilterComponent } from "./content-search/components/content-category-filter/content-category-filter.component";
import { ContentItemDetailsCardComponent } from "./content-search/components/content-item-details-card/content-item-details-card.component";
import { ContentSearchResultsListViewComponent } from "./content-search/components/content-search-results-list-view/content-search-results-list-view.component";
import { ContentSectionFilterComponent } from "./content-search/components/content-section-filter/content-section-filter.component";
import { ContentSearchComponent } from "./content-search/content-search.component";
import { DirectoryItemDetailsCardComponent } from "./directory-search/components/directory-item-details-card/directory-item-details-card.component";
import { DirectorySearchFiltersComponent } from "./directory-search/components/directory-search-filters/directory-search-filters.component";
import { DirectorySearchResultsListViewComponent } from "./directory-search/components/directory-search-results-list-view/directory-search-results-list-view.component";
import { DirectorySectionFilterComponent } from "./directory-search/components/directory-section-filter/directory-section-filter.component";
import { GoogleMapComponent } from "./directory-search/components/google-map/google-map.component";
import { HelpButtonComponent } from "./directory-search/components/help-button/help-button.component";
import { LocationFilterComponent } from "./directory-search/components/location-filter/location-filter.component";
import { PostcodeFilterComponent } from "./directory-search/components/postcode-filter/postcode-filter.component";
import { RecommendedLinksComponent } from "./directory-search/components/recommended-links/recommended-links.component";
import { DirectorySearchComponent } from "./directory-search/directory-search.component";
import { MultipleChoiceFacetComponent } from "./form-controls/multiple-choice-facet/multiple-choice-facet.component";
import { SingleChoiceFacetComponent } from "./form-controls/single-choice-facet/single-choice-facet.component";
import { SavedSearchesBarComponent } from "./saved-searches/saved-searches-bar/saved-searches-bar.component";

@NgModule({
    providers: [
        DatePipe
    ],
    imports: [
        A11yModule,
        OverlayModule,
        PortalModule,
        CommonModule,
        ReactiveFormsModule,
        GoogleMapsModule,
        MatDatepickerModule,
        MatMomentDateModule,
        NoopAnimationsModule,
        SharedLibraryModule,
        FormsModule,
        CommonComponentsModule,
        UmbracoLinkComponent,
        SavedSearchesBarComponent
    ],
    declarations: [
        DirectoryItemDetailsCardComponent,
        DirectorySearchFiltersComponent,
        DirectorySearchResultsListViewComponent,
        GoogleMapComponent,
        DirectorySearchComponent,
        DirectorySectionFilterComponent,
        HelpButtonComponent,
        PostcodeFilterComponent,
        RecommendedLinksComponent,
        LocationFilterComponent,
        ContentItemDetailsCardComponent,
        ContentSearchResultsListViewComponent,
        ContentSearchComponent,
        ContentSectionFilterComponent,
        ContentCategoryFilterComponent,
        AdvancedSearchComponent,
        MultipleChoiceFacetComponent,
        SingleChoiceFacetComponent
    ]
})
export class AdvancedSearchModule {
}
